import React from 'react';
import styled from 'styled-components/macro';
import delve from 'dlv';

import formatDate from 'helpers/formatDate';
import formatNumber from 'helpers/formatNumber';

import useSocialTopPostsData from './utils/useSocialTopPostData';

import { boxShadow } from 'styles/base-classes';

import PlatformIcon from 'components/data-containers/SocialTopPosts/TopPostTooltip/PlatformIcon';

import {
  Content,
  FormattedDate,
  Label,
  SemiBold,
  TooltipBottom as Bottom,
  TooltipTitle as Title,
  TooltipTop as Top,
  Value,
} from 'components/data-containers/SocialTopPosts/TopPostTooltip/TopPostTooltip.style';
import modularScale from 'styles/helpers/modular-scale';
import { ITopPost } from './types';
import { IArtist } from 'components/data-containers/BrowseEntities/shared/types';

const BoxShadow = styled.div`
  ${boxShadow};

  ${Title} {
    display: flex;
    align-items: center;
  }

  ${Top},
  ${Bottom} {
    font-size: ${modularScale(-1)};
  }
`;

interface IArtistMetadata {
  entity: IArtist;
}

interface ITopSocialPost {
  topPosts: ITopPost[];
  artistMetaData: IArtistMetadata[];
}

const TopSocialPost: React.FC<ITopSocialPost> = (props) => {
  const { topPosts, artistMetaData } = props;

  const topPost = useSocialTopPostsData(topPosts);

  if (!topPost || !artistMetaData) return null;

  const { entity, content, periodKey, platform, value } = topPost;
  const byEntityId = (el: IArtistMetadata): boolean =>
    el.entity.id === entity.id;
  const artist = artistMetaData.find(byEntityId);

  return (
    <BoxShadow>
      <Title>
        <Label>Top post last 30 days</Label>
        <PlatformIcon platform={platform} />
      </Title>

      <Top>
        <Content>{content}</Content>
        <Content>
          <SemiBold>
            — {delve(artist as IArtistMetadata, 'entity.displayName')}
          </SemiBold>{' '}
          <FormattedDate as="span">
            {formatDate(new Date(periodKey), 'day-short')}
          </FormattedDate>
        </Content>
      </Top>

      <Bottom as="p">
        Total engagement since posted
        <Value>{formatNumber(Number(value), 'number', true)}</Value>
      </Bottom>
    </BoxShadow>
  );
};

export default TopSocialPost;
